module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Did We Miss You?")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("lthough we’re fairly certain we found every last alternative career training program in the United States (and a few beyond it), there’s a remote possibility that we missed one or two. Or even three. If you know of a program or school that isn’t listed in this book but should be, please let us know. Thanks.")])]), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Lee and Joel Naftali"), _c('br'), _vm._v("P.O. Box 2066"), _c('br'), _vm._v("Santa Barbara, CA 93120"), _c('br'), _vm._v("JRNaftali@aol.com")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61884eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 84
// module chunks = 0